import { Contact } from "../common/contact";

export class SigningBillingContactBody {
  signingContact: Contact | null;
  signingContactRelationshipId: string | null;
  billingContact: Contact | null;
  billingContactRelationshipId: string | null;
  signingContactIsBillingContact: boolean;

  constructor(data: Partial<SigningBillingContactBody> = {}) {
    this.signingContact = data.signingContact ?? null;
    this.signingContactRelationshipId = data.signingContactRelationshipId ?? null;
    this.billingContact = data.billingContact ?? null;
    this.billingContactRelationshipId = data.billingContactRelationshipId ?? null;
    this.signingContactIsBillingContact = data.signingContactIsBillingContact ?? false;
  }
}
